import React, { useContext, useEffect, useState } from 'react';
import NftCard from "./nftCard";
import UserContext from "../contexts/UserContext";
import { getAllNFTs } from "../utils/commonInteractor";
import useLoader from "../hooks/useLoader";
import { ListingType } from '../utils/blockchainInteractor';

let allNFTs = [];
let totalCount = 0;
function MyNfts(props) {

    const { state } = useContext(UserContext);
    const [loader, showLoader, hideLoader] = useLoader();
    const [unlisted, setUnlisted] = useState([]);
    const [listed, setListed] = useState([]);

    useEffect(() => {
        init();
    }, [])

    function getPageData(NFTs) {
        const unlistedNfts = NFTs?.filter(nft=>nft.listingType === ListingType.NOT_LISTED);
        const listedNfts = NFTs?.filter(nft=>nft.listingType === ListingType.MARKETPLACE);
        setUnlisted(unlistedNfts)
        setListed(listedNfts)
    }

    const init = async () => {
        showLoader('Loading items....')
        const NFTs = await getAllNFTs(state?.user?.address);
        allNFTs = [...NFTs];
        getPageData(allNFTs);
        hideLoader();
    }

    return (
        <>
            {loader}
            <div className="user-gallery">
                <div className="container">
                    <div className="fox-heading text-center">
                        <h4>User Gallery</h4>
                    </div>
                    {
                        listed?.length > 0 && <div className="listed-item-wrp">
                            <div className="item-heading listed-item-heading text-center">
                                <h5>Listed Items</h5>
                            </div>
                            <div className="row gallery-row" id="listed-container">
                                {

                                    listed.map(card => (
                                        <NftCard isMyNft={true} nft={card} key={card.tokenId} />
                                    ))
                                }
                            </div>
                        </div>
                    }

                    {
                        unlisted?.length > 0 && <div className="unlisted-item-wrp">
                            <div className="item-heading listed-item-heading text-center">
                                <h5>Unlisted Items</h5>
                            </div>
                            <div className="row gallery-row" id="unlisted-container">
                                {

                                    unlisted.map(card => (
                                        <NftCard isMyNft={true} nft={card} key={card.tokenId} />
                                    ))
                                }
                            </div>
                        </div>
                    }

                </div>
            </div>
        </>
    )
}

export default MyNfts;
